import packageJson from '../../package.json'

export const MINIMUM_AMOUNT_PER_LINE_I2C = process.env.REACT_APP_MINIMUM_AMOUNT_PER_LINE_I2C
export const MAXIMUM_AMOUNT_PER_LINE_I2C = process.env.REACT_APP_MAXIMUM_AMOUNT_PER_LINE_I2C
export const WORKFLOW_PROJECT_ID = process.env.REACT_APP_WORKFLOW_PROJECT_ID
export const WORKFLOW_CUSTOMER_ALIAS = process.env.REACT_APP_WORKFLOW_CUSTOMER_ALIAS
export const API_HOST = process.env.REACT_APP_API_HOST
export const APP_VERSION = packageJson?.version
export const APP_NAME = packageJson?.name
export const GRACE_RATE=0